import { headers, BaseURLDev } from './config';

export function getOptRek2(){
   return fetch(`${BaseURLDev}/simantra/ref/rekdua`, {headers})
   .then(response => response.json())
}

export function getOptRek3(kd_rek_2){
   return fetch(`${BaseURLDev}/simantra/ref/rektiga?kd_rek_2=${kd_rek_2}`,{headers})
   .then(response =>response.json())   
}

export function getOptRek4(kd_rek_2, kd_rek_3){
   return fetch(`${BaseURLDev}/simantra/ref/rekempat?kd_rek_2=${kd_rek_2}&kd_rek_3=${kd_rek_3}`,{headers})
   .then(response =>response.json())
}

export function getOptRek5(kd_rek_2, kd_rek_3, kd_rek_4){
   return fetch(`${BaseURLDev}/simantra/ref/reklima?kd_rek_2=${kd_rek_2}&kd_rek_3=${kd_rek_3}&kd_rek_4=${kd_rek_4}`,{
      headers})
   .then(response => response.json())
}

export function getOptRek6(kd_rek_2, kd_rek_3, kd_rek_4, kd_rek_5){
   return fetch(`${BaseURLDev}/simantra/ref/rekenam?kd_rek_2=${kd_rek_2}&kd_rek_3=${kd_rek_3}&kd_rek_4=${kd_rek_4}&kd_rek_5=${kd_rek_5}`,{
      headers})
   .then(response => response.json())
}

export function filterOPD(kd_urusan, kd_bidang, kd_unit){
   return fetch(`${BaseURLDev}/simantra/ref/filteropd?kd_urusan=${kd_urusan}&kd_bidang=${kd_bidang}&kd_unit=${kd_unit}`,{
      headers})
   .then(response => response.json())
}


// WEBPACK FOOTER //
// ./src/_utils/getrekening.js